import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { FuseSharedModule } from '@fuse/shared.module';
import { ActivitiesSearchComponent } from './activities-search/activities-search.component';
import { FuseConfirmDialogModule, FuseSidebarModule } from '@fuse/components';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
@NgModule({
    declarations: [DashboardComponent, ActivitiesSearchComponent],
    imports: [
        CommonModule,
        // Shared Modules
        FuseSharedModule,
        FuseSidebarModule,
        FuseConfirmDialogModule,
        // Material Modules
        MatTabsModule,
        MatTooltipModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatSelectModule,
        MatDividerModule,
        DashboardRoutingModule,
    ]
})
export class DashboardModule { }
